import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from '@/stores';
import { useNavigate, useLocation } from 'react-router-dom';
import './RouteGuide.css';

export default function RouteGuide() {
  const location = useLocation();
  const dispatch = useDispatch();
  let keyPath = useSelector((state: RootState) => state.Menu.keyPath);
  let selectedKeys = useSelector((state: RootState) => state.Menu.selectedKeys);
  const navigate = useNavigate();
  const navigatePath = (key: string, index: number) => {
    let path = selectedKeys.slice(0, selectedKeys.indexOf(key) + 1).join('/');
    dispatch({
      type: 'POP_MENU_KEYPATH',
      payload: {
        keyPath: index,
        selectedKeys: index
      }
    })
    navigate(`/main/${path}`, { replace: true });
  }

  useEffect(() => {
    console.log('location changed in RouteGuide', location);
  }, [location])

  return (
    <section className="Guide">
      <section>当前位置: </section>
      <section>
        {keyPath.map((path: string, index: number) => {
          if(index !== selectedKeys.length - 1) {
            return <span key={path} className="path">{path}</span>
          }
          return <span key={path} className="path">{path}</span>
        })}
      </section>
    </section>
  )
}